import { CatalogFiltersData, Quest } from '../../types.d'

export function filterCatalogQuests(
  quests: Quest[],
  filters: CatalogFiltersData,
  search = ''
): Quest[] {
  let filtered = quests.slice()

  if (search) {
    const searchLower = search.toLowerCase()
    filtered = filtered.filter((quest) =>
      quest.name.toLowerCase().includes(searchLower)
    )
  }

  if (filters.categories.length > 0) {
    const selectedCategories = new Set(
      filters.categories.map((category) => category.toLowerCase())
    )

    filtered = filtered.filter((quest) =>
      (quest.categories || []).some((category) =>
        selectedCategories.has(category.slug.toLowerCase())
      )
    )
  }

  if (filters.horror.length > 0) {
    filtered = filtered.filter((quest) =>
      filters.horror.includes(quest.fear_level.toString())
    )
  }

  if (filters.complexity.length > 0) {
    filtered = filtered.filter((quest) =>
      filters.complexity.includes(quest.complexity.toString())
    )
  }

  if (filters.type) {
    filtered = filtered.filter(
      (quest) => String(quest.quest_type_id) === filters.type
    )
  }

  if (filters.metro && filters.metro.length > 0) {
    const selectedMetro = new Set(filters.metro)
    filtered = filtered.filter(
      (quest) => !!quest.metro && selectedMetro.has(quest.metro)
    )
  }

  const maxAge = filters.age ? Number(filters.age) : NaN
  if (!isNaN(maxAge)) {
    filtered = filtered.filter((quest) => {
      const questAge = quest.age ? parseInt(quest.age, 10) : NaN
      return isNaN(questAge) || questAge <= maxAge
    })
  }

  if (filters.haveEnglishVersion) {
    filtered = filtered.filter((quest) => quest.has_english_version)
  }

  // «Только Клаустрофобия»: квесты юрлиц со статусом оригинала.
  if (filters.original) {
    filtered = filtered.filter((quest) => quest.original === true)
  }

  if (filters.playersCount && typeof filters.playersCount === 'number') {
    const playersCount: number = Number(filters.playersCount)
    filtered = filtered.filter((quest) => quest.max_gamers >= playersCount)
  }

  return filtered
}
